module.exports = "/assets/fb4f1e162e2cb69475618c9b5d08b814.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WN.png
// module id = 3085
// module chunks = 0